
import { API_URL, showAlert, AuthContext } from "../util/api";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../header";
import Footer from "../footer";

export default function AdminLogin() {

    const [searchParams] = useSearchParams();

    const email = searchParams.get("email");
    const admin_token = searchParams.get("token");
    const path = searchParams.get("path");

    //how to check if a token  is correct...  


    const navigate = useNavigate();
    const { login, patientFunction, doctorFunction ,AdminFunction } = useContext(AuthContext);

    const [data, setData] = useState({ email: email, token: admin_token, 'admin': 'login'  });
    const [loading, setLoading] = useState(true);


    const handleSubmit = async () => {
       
        setLoading(true);

        try {
            const response = await axios.post(`${API_URL}/auth/admin_login`, data,
                {
                    headers: {
                        Authorization: `Bearer ${admin_token}`,
                        Accept: "application/json"
                    }
                });

            if (response.status === 200 && response.data.status === "successful") {
                login(response.data.token, response.data.user);
                AdminFunction("admin");

                const role = response.data.user.role;

                if (role === "patient") {
                    patientFunction(response.data.profile, response.data.user);
                }

                if (role === "doctor") {
                    doctorFunction(response.data.profile, response.data.user);
                }

                showAlert("success", "Success!", "Login successful");
                navigate(path);
            } else {
                showAlert("error", "Error!", response.data.message);
            }
        } catch (error) {
            showAlert("error", "Error!", "Server error. Check your network.");
        } finally {
            setLoading(false);
        }
    };

    //check admin login details  and  decide...  


     useEffect(()=>{
        handleSubmit();
     } ,  []);

    return (<>

        {loading &&
            <section>
                <h1 align="center"> Loading through Admin .....</h1>

                <br />

            </section>

        }


        <Footer />


    </>)

}